<template>
  <a-login-widget></a-login-widget>
</template>

<script>
export default {
  name: 'LoginPage',
}
</script>